module.exports = __webpack_public_path__ + "img/MC-Logo-Web-White.9fc6afc.png";